import { api } from './http'

/** Shape of `GET /health` (SPEC.md §9.2). */
export interface HealthResponse {
  status: 'ok'
  app: string
  environment: string
  version: string
}

/**
 * Ask the API whether it is alive.
 *
 * @example
 * const { version } = await fetchHealth()
 */
export function fetchHealth(signal?: AbortSignal): Promise<HealthResponse> {
  return api.get<HealthResponse>('/health', signal)
}
